import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";

export const saveResourceDetails = async (resourceData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SalaryProcess/ResourceMasters`,
      resourceData,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving resource details!";
  }
};

export const fetchRoles = async () => {
  try {
    const response = await axios.get(`${Base_URL}/RoleMaster/GetAllRoles`);
    return response.data.map((role) => ({
      code: role.code,
      description: role.description,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch roles";
  }
};

export const fetchDepartments = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/DepartmentMaster/GetAllDepartments`,
    );
    return response.data.map((dept) => ({
      code: dept.code,
      description: dept.description,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch departments";
  }
};

export const fetchBanks = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/BankMaster/GetAllBanks/id?id=${id}`,
    );
    return response.data.map((bank) => ({
      code: bank.code,
      description: bank.description,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch banks";
  }
};

export const fetchEmployeeTypes = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/EmployeeTypeMaster/GetAllEmployeeTypes`,
    );
    return response.data.map((type) => ({
      code: type.code,
      description: type.description,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch employee types";
  }
};

export const fetchPaymentGroups = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/PaymentDateGroupMaster/GetAllGroups`,
    );
    return response.data.map((group) => ({
      code: group.code,
      description: group.description,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch payment groups";
  }
};

export const fetchCostCenters = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CostCenterMaster/GetAllCostCenters`,
    );
    return response.data.map((center) => ({
      code: center.costCenterCode,
      description: center.costCenterName,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch cost centers";
  }
};

export const fetchOfficeCodes = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeGetData/${id}`);
    return response.data.map((office) => ({
      code: office.officeCode,
      description: office.officeName,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch office codes";
  }
};

export const fetchPaymentBanks = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HouseBank/GetAllDistinctBanks/id?id=${id}`,
    );
    return response.data.map((bank) => ({
      code: bank,
      description: bank,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch payment banks";
  }
};

export const fetchAllResources = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/ResourceMasters/${id}`,
    );
    return response.data.map((resource) => ({
      value: resource.resourceId,
      label: `${resource.resourceId} - ${resource.name}`,
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

export const fetchSalaryConfig = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/GetSalaryConfig/${id}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};
export const fetchLeaveName = async (orgId) => {
  try {
    const response = await axios.get(`${Base_URL}/Resource/GetLeavePolicy`, {
      params: { org_id: orgId },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resource!";
  }
};

export const fetchResourceById = async (resourceId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/GetResourceById/${resourceId}`,
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resource details!";
  }
};

export const fetchStationsByResourceId = async (resourceId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/StationResourceMapping/GetStationByResourceId/${resourceId}`,
    );

    return response.data.map((station) => ({
      stationId: station.stationId,
      stationName: station.stationName,
      recordGuid: station.recordGuid,
      organisationId: station.organistionId,
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch stations by resource id";
  }
};

export const fetchCompanyByCompanyCode = async (companyCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CompanyCode/GetByCompanyCode/${companyCode}`,
    );

    // backend returns { success, message, data }
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch company details!";
  }
};

export const getResourceDetails = async ({ resourceId, mavUserId }) => {
  try {
    const response = await axios.get(`${Base_URL}/Resource/GetResource`, {
      params: { resourceId, mavUserId },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resource!";
  }
};
